/**************************************************
 * Nombre:       Seccion_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import React, {useContext, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {theme} from "../../Tema";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {CASILLA_FECHA_DATOS, CASILLA_PARRAFO} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {ManageSearch} from '@mui/icons-material'
import Dialogo_Soporte from "../Dialogos/Dialogo_Soporte";
import Dialogo_Soporte_Ver from "../Dialogos/Dialogo_Soporte_Ver";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {where} from "firebase/firestore";
import {usuarioContext} from "../../App";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";


const Seccion_Soporte = () => {
    const {sCell} = useResponsive()
    const cData = useContext(usuarioContext)
    const [w, setWheres] = useState([where('idUsuario', '==', cData.usuario.id)])
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'soportes', wheres: w})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Soporte,
        titulo: 'Detalles del soporte',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoVer, abrir: abrirVer} = useDialogo({
        Componente: Dialogo_Soporte_Ver,
        titulo: 'Respuesta del soporte',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrirVer(data)
                break
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}
            >

                <Dialogo/>

                <DialogoVer/>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: sCell ? 32 : 36,
                                        fontWeight: 800
                                    }}>
                                        Soporte
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 0.5 : 0}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        ¿Tienes dudas o inconvenientes? Nuestro sistema de tickets está disponible para
                                        brindarte ayuda rápida y efectiva en cada paso de tu proceso.
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}}
                              sx={{justifyContent: 'flex-end', mt: sCell ? 2 : 0}}>


                            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-end'}}>
                                <Button
                                    onClick={() => abrir()} variant={'outlined'} sx={{px: 4, fontWeight: 400}}>
                                    Nueva Solicitud
                                </Button>
                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', mt: 6, px: sCell ? 0 : 4}}>
                    <Tabla_Filtro
                        nombre={'Solicituedes de soporte'}
                        descripcion={`${props.numeroFilas} en historial`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Soporte


const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Asunto',
        direccion: 'left',
        propiedades: ['consecutivo', 'asunto'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Descripcion',
        direccion: 'left',
        propiedad: 'descripcion',
        tipo: CASILLA_PARRAFO

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedades: ['estado'],
        fecha: 'fechaRespuesta',
        tipo: CASILLA_FECHA_DATOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]

